import { useEffect, useState } from 'react';
import {
  PhoneNumberUtil,
  PhoneNumberFormat,
  PhoneNumberType,
} from 'google-libphonenumber';

export type CountryData = {
  name: string;
  iso2: string;
  flagUrl: string;
  dialCode: string;
  mask: string;
};

export function useCountriesWithPhoneMasks() {
  const [countries, setCountries] = useState<CountryData[]>([]);

  useEffect(() => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const isoRegions = Array.from(phoneUtil.getSupportedRegions());
    const generated: CountryData[] = [];

    isoRegions.forEach((iso2) => {
      try {
        const example = phoneUtil.getExampleNumberForType(
          iso2,
          PhoneNumberType.MOBILE,
        );

        if (!example) return;

        const dialCode = '+' + phoneUtil.getCountryCodeForRegion(iso2);
        const formatted = phoneUtil.format(example, PhoneNumberFormat.NATIONAL);
        const mask = formatted.replace(/\d/g, '9');

        const flagUrl = `https://flagcdn.com/w40/${iso2.toLowerCase()}.png`;

        generated.push({
          name: iso2,
          iso2,
          flagUrl,
          dialCode,
          mask,
        });
      } catch {}
    });

    setCountries(generated);
  }, []);

  return countries;
}
